import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../../app/store";
import jwt_decode from "jwt-decode";

export enum ROLE {
  ADMIN = "admin",
  GeneralManager = 1,
  AssistantGeneralManager = 2,
  GroupManager = 3,
  Manager = 4,
  TeamLead = 5,
  User = 6,
}

export interface User {
  id: string;
  name: string;
  surname: string;
  role: ROLE;
}

type AuthState = {
  user: User | any;
  token: string | any;
  refreshToken: string | any;
  isAuthenticated: any;
};

const slice = createSlice({
  name: "auth",
  initialState: {
    user: localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user") as any)
      : null,
    token: localStorage.getItem("token"),
    isAuthenticated: localStorage.getItem("isAuthenticated")
      ? localStorage.getItem("isAuthenticated")
      : false,
  } as AuthState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      localStorage.clear();
    },
    setCredentials: (state, action: PayloadAction<any>) => {
      //const { accessToken, refreshToken } = action.payload.data;
      const userInfo = jwt_decode<any>(action.payload);

      userInfo.role = "admin";
      userInfo.name = userInfo.email.split(".")[0];
      userInfo.surname = userInfo.email.split(".")[1].split("@")[0];
      userInfo.id =
        userInfo[
          "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
        ];

      populateStorage(userInfo, action.payload, true);

      state.user = userInfo;
      state.token = action.payload;
      //state.refreshToken = refreshToken;
      state.isAuthenticated = true;
    },
    tokenReceived: (
      state,
      { payload: { token } }: PayloadAction<{ token: string }>
    ) => {
      state.token = token;
    },
  },
});

function populateStorage(user: any, token: string, isAuthenticated: any) {
  localStorage.setItem("user", JSON.stringify(user));
  localStorage.setItem("token", token);
  localStorage.setItem("isAuthenticated", isAuthenticated);
}

export const { setCredentials, tokenReceived, logout } = slice.actions;

export default slice.reducer;

export const selectToken = (state: RootState) => state.auth.token;
export const selectCurrentUser = (state: RootState) => state.auth.user;
export const selectIsAuthenticated = (state: RootState) =>
  state.auth.isAuthenticated;
